"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          iconPrefix = _this$props.iconPrefix,
          size = _this$props.size,
          link = _this$props.link,
          info = _this$props.info,
          success = _this$props.success,
          danger = _this$props.danger,
          inverted = _this$props.inverted,
          outlined = _this$props.outlined,
          rounded = _this$props.rounded,
          onClick = _this$props.onClick,
          href = _this$props.href,
          primary = _this$props.primary,
          complement = _this$props.complement,
          disabled = _this$props.disabled,
          loading = _this$props.loading,
          selected = _this$props.selected,
          text = _this$props.text,
          reverse = _this$props.reverse,
          tabIndex = _this$props.tabIndex,
          title = _this$props.title,
          target = _this$props.target,
          rel = _this$props.rel;
      var buttonClass = (0, _classnames2.default)('button', 'frikin-button', className, (_classnames = {}, _defineProperty(_classnames, "is-".concat(size), size), _defineProperty(_classnames, 'is-link', link), _defineProperty(_classnames, 'is-info', info), _defineProperty(_classnames, 'is-success', success), _defineProperty(_classnames, 'is-danger', danger), _defineProperty(_classnames, 'is-inverted', inverted), _defineProperty(_classnames, 'is-outlined', outlined), _defineProperty(_classnames, 'is-rounded', rounded), _defineProperty(_classnames, 'is-primary', primary), _defineProperty(_classnames, 'is-complement', complement), _defineProperty(_classnames, 'is-loading', loading), _defineProperty(_classnames, 'is-selected', selected), _defineProperty(_classnames, 'is-text', text), _defineProperty(_classnames, 'has-icon', !!icon), _defineProperty(_classnames, 'is-disabled', disabled), _classnames), className);
      if (href && disabled) href = null;
      var c = !!href ? 'a' : 'button';
      return _react.default.createElement(c, {
        className: buttonClass,
        onClick: onClick,
        disabled: disabled,
        tabIndex: tabIndex,
        title: title,
        href: href,
        target: target,
        rel: rel
      }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon && !reverse && /*#__PURE__*/_react.default.createElement("span", {
        className: "icon is-medium"
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        icon: icon,
        prefix: iconPrefix
      })), children && /*#__PURE__*/_react.default.createElement("span", null, children), icon && reverse && /*#__PURE__*/_react.default.createElement("span", {
        className: "icon is-medium"
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        icon: icon,
        prefix: iconPrefix
      }))));
    }
  }]);

  return Button;
}(_react.default.Component);

exports.default = Button;
Button.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any,
  icon: _propTypes.default.string,
  iconPrefix: _propTypes.default.string,
  size: _propTypes.default.oneOf(['tiny', 'small', 'medium', 'large', 'regular']),
  link: _propTypes.default.bool,
  info: _propTypes.default.bool,
  success: _propTypes.default.bool,
  danger: _propTypes.default.bool,
  inverted: _propTypes.default.bool,
  outlined: _propTypes.default.bool,
  rounded: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  href: _propTypes.default.string,
  target: _propTypes.default.string,
  rel: _propTypes.default.string,
  primary: _propTypes.default.bool,
  complement: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  text: _propTypes.default.bool,
  reverse: _propTypes.default.bool
};
Button.defaultProps = {
  size: 'regular'
};